// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EmployeeCode_Wrapper__Um01V","Show":"EmployeeCode_Show__2sq1h","Background":"EmployeeCode_Background__1SF43","Close":"EmployeeCode_Close__9cb7s"};